import { render, staticRenderFns } from "./LastestNews.vue?vue&type=template&id=1dc2984f&scoped=true&"
import script from "./LastestNews.vue?vue&type=script&lang=ts&"
export * from "./LastestNews.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc2984f",
  null
  
)

export default component.exports